import React from 'react';
import { Typography } from 'antd';
import IrrigationChart from '../../../Helpers/Charts/IrrigationChart';

const { Title, Text } = Typography;

const IrrigationChartSection = ({ data, selectedPoint }) => {

  let hpfp_percent;
  let hcc_percent;

  if (selectedPoint && selectedPoint.hpfp_percent !== null && selectedPoint.hpfp_percent !== undefined && selectedPoint.hpfp_percent !== '') {
    hpfp_percent = Number(selectedPoint.hpfp_percent);
  }

  if (selectedPoint && selectedPoint.hcc_percent !== null && selectedPoint.hcc_percent !== undefined && selectedPoint.hcc_percent !== '') {
    hcc_percent = Number(selectedPoint.hcc_percent);
  }


  return (
    <section>
      <Title level={3} className="text-xl md:text-2xl font-semibold mb-4">Données d'irrigation</Title>
      <Text className="mb-4 block">Ce graphique montre les quantités d'eau utilisées pour l'irrigation au fil du temps.</Text>
      <IrrigationChart data={data} hpfp_percent={hpfp_percent} hcc_percent={hcc_percent} />
    </section>
  );
};

export default IrrigationChartSection;
